var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videojs-wrap"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"playsInline":"","muted":"","autoplay":_vm.autoplay,"options":_vm.options},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }